<template>
<div class="chapter">
<div class="inner_page">
<div class="chapterbody">
<a id="page_429"></a>
<h1 id="_RWTOC-9"><a href="#/xhtml/content#RWTOC-9">GOVERNOR<br/>GENERAL’S<br/>AWARDS</a></h1>
<a id="page_430"></a>
<a id="page_431"></a>
<p class="center" style="page-break-before:always; margin-top:25%; font-family:sans-serif"><b>The Canada Council for the Arts Announces the Winners of the<br/>2001 Governor General’s Literary Awards</b></p>
<h2><i>Ottawa, November 14, 2001</i></h2>
<p class="noindent">The Canada Council for the Arts announced today the names of the winners of the 2001 Governor General’s Literary Awards, in English and French, in the categories of fiction, poetry, drama, nonfiction, children’s literature (text and illustration) and translation. </p>
<p>The awards will be presented today by Her Excellency the Right Honourable Adrienne Clarkson,</p>
<p>Governor General of Canada, and Jean-Louis Roux, Chairman of the Canada Council for the Arts, at a 4 p.m. ceremony at Rideau Hall.</p>
<p>Each laureate will receive a cheque for $15,000 and a specially-crafted copy of the winning book bound by master bookbinder Pierre Ouvrard. The Governor General will also present certificates to the publishers of the prize-winning books, and the Canada Council will provide each publisher with a $3,000 grant to support promotional activities.</p>
<p>“The recipients of this year’s Governor General’s Literary Awards give us an artistic prism through which we see our lives and spirits <a id="page_432"></a>refracted,” said the Governor General. “The different voices of these writers reflect the reality of human life and its varied dreams, beliefs, and desires.”</p>
<p>“The winning books remind us once again of the immense power of the written word to stimulate us, make us reflect on our condition, and give us cause for celebration in even the most difficult times,” said Canada Council Chairman Jean-Louis Roux. “Our writers are the guardians of the human spirit, and their achievements should be a source of inspiration and pride for all Canadians.”</p>
<p class="noindent2"><b>Fiction Written in English</b></p>
<p class="noindent2">Richard B. Wright, St. Catharines, Ontario, for <i>Clara Callan</i> (HarperFlamingo Canada: A Phyllis Bruce Book)</p>
<p>English-language jury’s citation: “<i>Clara Callan</i> brilliantly transfers ordinary lives onto a wider canvas to portray the grandeur of an era. In a style that is understated yet compelling, Wright blends the forms of the letter and the journal to construct a powerful narrative.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm3.vue?56799742